export const version = "hash/5.4.0";
//# sourceMappingURL=_version.js.map